// extracted by mini-css-extract-plugin
export default {"row":"style_row__2Poo-","searchBox":"style_searchBox__9PAOi","smallText":"style_smallText__BvlDp"};